import React, { useState } from "react";
import {
	Dialog,
	DialogContent,
	DialogActions,
	DialogTitle,
	Box,
	CloseIcon,
	Grid,
} from "../../../common/MaterialComponent";
import {
	ButtonPrimary,
	IconButtonPrimary,
	primaryColor,
} from "../../../common/sharedStyle";
import "./USSDScriptDialog.css";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";

export interface GenerateScriptProps {
	open: boolean;
	scriptDetail: string;
	ivrFlowTitle: string;
	closeDialog: () => void;
}

export const USSDScriptDialog: React.FC<GenerateScriptProps> = ({
	open,
	scriptDetail,
	ivrFlowTitle,
	closeDialog,
}) => {
	const strings = useGetComponentStringsContext().USSDScriptDialog;
	const [isContentCopied, setIsContentCopied] = useState(false);

	const downloadTxtFile = () => {
		const linkElement = document.createElement("a");
		const file = new Blob([scriptDetail], {
			type: "text/plain",
		});
		linkElement.href = URL.createObjectURL(file);
		// download file as text file
		linkElement.download = ivrFlowTitle.split(" ").join("_") + ".txt";
		document.body.appendChild(linkElement);
		linkElement.click();
	};

	const copyTextToClipBoard = () => {
		const selection = window.getSelection();
		const range = document.createRange();
		range.selectNodeContents(document.getElementById("scriptDetail")!);
		selection!.removeAllRanges();
		selection!.addRange(range);
		document.execCommand("Copy");
		selection!.removeAllRanges();
		setIsContentCopied(true);
		// added timeout to hide content copied info message after 3000 ms
		setTimeout(() => {
			setIsContentCopied(false);
		}, 3000);
	};

	return (
		<div data-testid="scriptContainer">
			<Dialog open={open} fullWidth maxWidth="md" className="scriptDialog">
				<DialogTitle className="dialogTitle">
					<Box display="flex" alignItems="center">
						<Box flexGrow={1} className={primaryColor}>
							{strings.scriptDialogHeader}
						</Box>
						<Box>
							<IconButtonPrimary
								data-testid="closeBtn"
								onClick={() => closeDialog()}
							>
								<CloseIcon />
							</IconButtonPrimary>
						</Box>
					</Box>
				</DialogTitle>
				<DialogContent dividers>
					{isContentCopied && (
						<div className="copyMessage" data-testid="copyMessage">
							{strings.copyToClipboardMessage}
						</div>
					)}
					<Grid container>
						<div
							data-testid="scriptContent"
							className="scriptDetail"
							id="scriptDetail"
						>
							<pre>{scriptDetail}</pre>
						</div>
					</Grid>
				</DialogContent>
				<DialogActions>
					<ButtonPrimary data-testid="copyBtn" onClick={copyTextToClipBoard}>
						{strings.copyToClipboardButton}
					</ButtonPrimary>
					<ButtonPrimary data-testid="downloadBtn" onClick={downloadTxtFile}>
						{strings.downloadButton}
					</ButtonPrimary>
				</DialogActions>
			</Dialog>
		</div>
	);
};
